export default Object.freeze({
  // SAMPLE_SET_DELETE: 'SAMPLE_SET_DELETE',
});
